// @flow
import type { State } from 'app/common/redux/reducers/types';

export const profileBoardsFeedId = (username: string, sort?: string) => `${username}:${sort || ''}`;

export const getProfileBoardFeed = (
  state: State,
  props: { username: string, boardOrder: string },
) => state.feeds.profileBoards[profileBoardsFeedId(props.username, props.boardOrder)];

export const getProfileBoardView = (
  state: State,
  props: { isOwnProfile: boolean, isOverview?: boolean },
) =>
  props.isOverview
    ? 'xxWide'
    : (props.isOwnProfile && state.ui.views && state.ui.views.profileBoardView) || 'wide';
